import VouchersLinesForm from '../../../../components/Purchasing/Voucher/Lines/VouchersLinesForm'
import React from 'react'
import { Modal } from 'antd'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'
import { MODAL_TYPE_NEW } from '../../../../elements/Hooks/useModalData'

function VouchersLinesModal(props) {
  const {
    removeLine,
    submitLine,
    updateLine,
    visible,
    modalType,
    formRefLine,
    onCancel,
    removingLine,
    isUpdatable,
    isConfirmed,
    submittingLine,
  } = props
  const isNew = modalType === MODAL_TYPE_NEW
  return (
    <Modal
      visible={visible}
      title={'Vouchers Lines'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          visible={isUpdatable}
          isRemovable={!isConfirmed}
          submit={submitLine}
          remove={removeLine}
          update={updateLine}
          removing={removingLine}
          submitting={submittingLine}
          title={'Lines'}
          isNew={isNew}
          isEdit={!isNew}
        />
      }
      width={'75%'}>
      <VouchersLinesForm ref={formRefLine} {...props} />
    </Modal>
  )
}

VouchersLinesModal.propTypes = {}
VouchersLinesModal.defaultProps = {}

export default VouchersLinesModal
